export class GetScanJobResponse {
    'job';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "job",
            "baseName": "job",
            "type": "ScanJob",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetScanJobResponse.attributeTypeMap;
    }
    constructor() {
    }
}
